import { Box, Container, Grid, Link, Typography, useTheme, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { PAGES } from "../../constants";

interface AboutChubbProps {
  componentLocation: "splash" | string;
}

const BorderedContent = styled(Box)(({ theme }) => ({
  borderTop: `4px solid ${theme.custom.magenta}`,
  paddingTop: theme.spacing(2),
  marginBottom: theme.spacing(4)
}));

const AboutChubb: React.FC<AboutChubbProps> = ({ componentLocation }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isDashboard = componentLocation === 'dashboard';

  // Main content
  const content = (
    <>
      <Typography variant="h5" sx={{ mb: 1 }} color="white">
        About Chubb's Cyber Practice in the U.S.
      </Typography>
      {isXs && (
        <BorderedContent />
      )}
      <Typography variant="body1" color="white">
        {PAGES['splash'].contents.aboutChubbText1} Visit{' '}
        <Link
          href="https://www.chubb.com/cyber"
          target="_blank"
          rel="noopener noreferrer"
          title="About Chubb - Open in new window"
          sx={{
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
              color: 'white',
              textDecoration: 'underline'
            }
          }}
        >
          www.chubb.com/cyber
        </Link>
        {' '}{PAGES['splash'].contents.aboutChubbText2}
      </Typography>
    </>
  );

  return (
    <Box
      className="about-chubb-container"
      sx={{
        ...(isDashboard
          ? {
              // For dashboard: use 100% width to avoid overflow with drawer margin
              width: '100%',
              position: 'relative',
            }
          : {
              // For splash: use full bleed technique
              width: '100vw',
              position: 'relative',
              left: '50%',
              right: '50%',
              marginLeft: '-50vw',
              marginRight: '-50vw',
            }),
        backgroundColor: "#AFAFAF",
        py: 3, // vertical padding
        mt: componentLocation === "splash" ? 8 : 0
      }}
    >
      <Container maxWidth={isDashboard ? false : "lg"} disableGutters={isDashboard}>
        <Grid container>
          <Grid size ={{xs: 12 ,lg: isDashboard ? 12 : 9}} sx={{ mx: isDashboard ? 2 : 0}}>
            {content}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutChubb;